import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-us-second',
  templateUrl: './about-us-second.component.html',
  styleUrls: ['./about-us-second.component.css']
})
export class AboutUsSecondComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
